/**
 * Текущий язык вне React (ошибки API, форматирование дат, адаптеры, тосты из хуков).
 * Источник истины — LocaleProvider: он вызывает `setCurrentLang` при смене языка.
 */
import { storageKeys } from '@/config/app';
import { local } from '@/lib/storage';
import {
  DEFAULT_LOCALE,
  isLocaleCode,
  translate,
  translatePlural,
  type LocaleCode,
  type PluralKey,
  type UiKey,
  type Vars,
} from './dictionary';

export function readStoredLang(): LocaleCode {
  const stored = local.get(storageKeys.lang);
  return isLocaleCode(stored) ? stored : DEFAULT_LOCALE;
}

let current: LocaleCode = readStoredLang();
const listeners = new Set<(lang: LocaleCode) => void>();

export function getLang(): LocaleCode {
  return current;
}

export function setCurrentLang(lang: LocaleCode): void {
  if (lang === current) return;
  current = lang;
  listeners.forEach((fn) => fn(lang));
}

export function onLangChange(fn: (lang: LocaleCode) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** Перевод по текущему языку — для кода вне компонентов. В компонентах используйте `useT()`. */
export function t(key: UiKey, vars?: Vars): string {
  return translate(current, key, vars);
}

export function tp(key: PluralKey, n: number, vars?: Vars): string {
  return translatePlural(current, key, n, vars);
}

/** Локаль для Intl (даты, числа): en → en-US, ru → ru-RU. */
export function intlLocale(lang: LocaleCode = current): string {
  return lang === 'ru' ? 'ru-RU' : 'en-US';
}
